<template>
    <div class="app-container">
    <el-row class="headTop">
      <el-col :span="22">
        <span v-if="showShop">
        分店：<el-select class="w150 mr20" v-model="params.shopNum" clearable  placeholder="请选择分店">
          <el-option
          v-for="item in this.shopList"
          :key="item.shopNum"
          :label="item.name"
          :value="item.shopNum"
          ></el-option>
        </el-select>
        </span>
        票名：<el-input
          class="w150 mr20"
          placeholder="请输入票名"
          v-model="params.name"
          clearable>
        </el-input>
        <el-button style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
      </el-col>
      <el-col :span="2">
        <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
      </el-col>
    </el-row>
    <el-dialog title="票信息"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="100px">
            <el-form-item label="票类型" prop="typeId" v-if="addType==1">
              <el-select v-model="formparams.typeId" placeholder="请选择">
                <el-option v-for="item in this.options"
                :key="item.tid"
                :label="item.ticketType"
                :value="item.tid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="票名称" prop="ticketName">
              <el-input class="w220" v-model="formparams.ticketName" placeholder="请输入票明" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="上传票图" required ref="uploadElement">
              <el-upload
                :class="{uploaderNone:hideUpload}"
                action="aa"
                ref="upload"
                list-type="picture-card"
                :auto-upload="false"
                :http-request="uploadFile"
                :file-list="fileList"
                multiple
                :limit="1"
                :on-change="onChange"
                :on-remove="handleRemove"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                >
                <i class="el-icon-plus"></i>
              </el-upload>
              *提示*：为了更好的用户体验，图片请提供360*180像素，文件大小不超过500kb。
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="票价" prop="price">
                  <el-input class="w220" v-model="formparams.price" placeholder="请输入票的价格"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否限制出售总量" label-width="180px">
                  <el-switch
                    v-model="formparams.isreduce"
                    active-value= '1'
                    inactive-value= '0'
                    active-text="是"
                    inactive-text="否">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出售总量" prop="number" v-if="formparams.isreduce==='1'">
                  <el-input  class="w220" v-model.number="formparams.number" placeholder="请输入出售总量"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="formparams.validityTime==0">
              <el-col :span="8">
                <el-form-item label="是否限制购买数量" label-width="180px">
                  <el-switch
                    v-model="formparams.isRestrictionSaleNum"
                    active-value= '1'
                    inactive-value= '0'
                    active-text="是"
                    inactive-text="否">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="购买数量" prop="saleNum" v-if="formparams.isRestrictionSaleNum==='1'">
                  <el-input  class="w220" v-model.number="formparams.saleNum" placeholder="请输入购买数量"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="票说明" prop="subtitle">
              <editor-bar v-model="formparams.subtitle" :isClear="isClear"></editor-bar>
              <!-- <el-input type="textarea" :rows="4" v-model="formparams.subtitle" placeholder="请输入票的说明"></el-input> -->
            </el-form-item>
            <el-form-item label="分店" prop="shopNum">
                <el-select v-model="formparams.shopNum" placeholder="请选择">
                    <el-option
                    v-for="item in this.shopList"
                    :key="item.shopNum"
                    :label="item.name"
                    :value="item.shopNum"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-row>
              <el-col :span="10">
                <el-form-item label="开始时间" prop="bigintime">
                  <el-time-select
                    placeholder="起始时间"
                    v-model="formparams.bigintime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '24:00'
                    }">
                  </el-time-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束时间" prop="endtime">
                  <el-time-select
                    placeholder="结束时间"
                    v-model="formparams.endtime"
                    :picker-options="{
                      start: '00:30',
                      step: '00:30',
                      end: '24:00',
                      minTime: formparams.bigintime
                    }">
                  </el-time-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="使用时间">
                <el-checkbox-group v-model="timeList">
                  <el-checkbox  v-for="(item, i) in weekS" :key="i" :label="item.value">{{item.label}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="有效期" prop="validityTime">
              <el-input class="w220" v-model.number="formparams.validityTime" placeholder="有效期0代表当天1代表明天" maxlength="20"></el-input>(单位:天)
            </el-form-item>
            <!-- 活动配置 -->
            <el-row>
              <el-col :span="8">
                <el-form-item label="活动方式">
                  <el-select 
                    clearable 
                    v-model="formparams.favorabletype"
                    placeholder="请选择">
                    <el-option v-for="item in this.favorabletypeS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item  label="优惠折扣" v-if="formparams.favorabletype ==1||formparams.favorabletype==''" >
                  <el-input class="w220" maxlength="3"  
                  v-model.number="formparams.activity" placeholder="请输入折扣（1-100）"></el-input>
                </el-form-item> 
                <el-form-item label="票赠送" v-if="formparams.favorabletype ==2">
                  买<el-input v-model="buyNum" class="w220" placeholder="请输入"></el-input><span style="padding:0 20px;">/</span>赠送<el-input v-model="giveNum" style="width:120px" placeholder="请输入"></el-input>(单位：个)
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="活动开始/结束时间">
              <el-date-picker
                v-model="date"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                :default-time="['00:00:00', '23:59:59']"
                end-placeholder="结束日期">
              </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column label="票类型"  prop="tbTicketType.ticketType" :filters="titleList" :filter-method="filterHandler" width="100"></el-table-column> -->
        <el-table-column prop="name"  width="150" label="名称"></el-table-column>
        <el-table-column  width="100" label="分店">
          <template slot-scope="scope">
            <div> {{scope.row.shopnum|caseType}} </div>
          </template>
        </el-table-column>     
        <el-table-column label="票图片" width="120">
          <template slot-scope="scope">
            <img style="width:100px;height:50px;" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.picture" alt="">
                <!-- <img style="width:100px;height:50px;" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.picture" alt=""> -->
          </template>
        </el-table-column>
        <el-table-column prop="price" width="100" label="价格"></el-table-column>
        <el-table-column prop="number" width="70" label="总数量"></el-table-column>
        <el-table-column  width="150" label="出售时间">
          <template slot-scope="scope" v-if="scope.row.ticketConfig&&scope.row.ticketConfig.bigintime">
            {{scope.row.ticketConfig.bigintime}} - {{scope.row.ticketConfig.endtime}}
          </template>
        </el-table-column>
        <!-- <el-table-column  width="150" prop="ticketConfig.endtime" label="结束时间"></el-table-column> -->
        <el-table-column  width="70" label="有效期">
          <template slot-scope="scope">
            <span v-if="scope.row.ticketConfig&&scope.row.ticketConfig.validitytime&&scope.row.ticketConfig.validitytime!=0">{{scope.row.ticketConfig.validitytime}}天</span>
            <span v-else>当天</span>
          </template>
        </el-table-column>
        <el-table-column label="使用时间" width="100">
          <template slot-scope="scope">
            <!-- <div v-for="(item,index) in scope.row.ticketConfig.usetime" :key="index"> -->
              <span v-if="scope.row.ticketConfig">{{scope.row.ticketConfig.usetime}}</span>
              <!-- <span v-if="item == '2'">星期二</span>
              <span v-if="item == '3'">星期三</span>
              <span v-if="item == '4'">星期四</span>
              <span v-if="item == '5'">星期五</span>
              <span v-if="item == '6'">星期六</span>
              <span v-if="item == '7'">星期日</span> -->
            <!-- </div> -->
          </template>
        </el-table-column>
        <el-table-column  width="150" prop="subtitle" label="票说明">
           <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" width="300px">
               <div class="menuTree" v-html="scope.row.subtitle"></div>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">鼠标放上查看详情</el-tag>
                </div>
              </el-popover>
           </template>
        </el-table-column>
        <el-table-column label="活动类型" width="250" >
          <template slot-scope="scope" v-if="scope.row.ticketConfig&&scope.row.ticketConfig.favorabletype">
            <div v-if="scope.row.ticketConfig.favorabletype ==1">类型：折扣</div>
            <div v-if="scope.row.ticketConfig.favorabletype ==2">类型：赠送</div>
            <div v-if="scope.row.ticketConfig.favorabletype ==1">折扣优惠：{{scope.row.ticketConfig.activity}}折</div>
            <div v-if="scope.row.ticketConfig.favorabletype ==2">折扣优惠：{{scope.row.ticketConfig.activity}}</div>
            <div v-if="scope.row.ticketConfig.activestarttime"> 开始时间：{{scope.row.ticketConfig.activestarttime}}</div>
            <div v-if="scope.row.ticketConfig.activeendtime"> 结束时间：{{scope.row.ticketConfig.activeendtime}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="折扣优惠">
          <template slot-scope="scope">
            <span v-if="scope.row.ticketConfig.favorabletype ==1">{{scope.row.ticketConfig.activity}}折</span>
            <span v-if="scope.row.ticketConfig.favorabletype ==2">{{scope.row.ticketConfig.activity}}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="活动开始时间" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.ticketConfig.activestarttime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="活动结束时间" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.ticketConfig.activeendtime}}</span>
          </template>
        </el-table-column> -->

        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button  type="danger" @click="removeList(scope.row.id)" v-show="scope.row.type==1">下架</el-button>
            <el-button  type="success" @click="addList(scope.row.id)" v-show="scope.row.type!=1">上架</el-button>
            <el-button  type="warning" @click="gobackTicket(scope.row)">退款设置</el-button>
            <el-button style="margin-top:10px;"  type="warning" @click="goCardTicket(scope.row)">会员卡购票设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import { getOnlineTicketInfo, updateTicketInfo, insertOnlineTicketInfo, getTicketTypes, getShops } from "../../api/configApi";
import EditorBar from '../../components/wangEnduit'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      showShop:false,
      hideUpload:false,
      isClear:false,
      date:[],//开始时间结束时间
      rules:{
        typeId:[
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        ticketName:[
          { required: true, message: '请输入票名', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { pattern:/^(([0-9]|([1-9][0-9]{0,9}))((\.[0-9]{1,2})?))$/, message: '请输入正确金额格式', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '数量不能为空', trigger:'blur'},
          { type: 'number', message: '数量必选大于0'}
        ],
        saleNum: [
          { required: true, message: '数量不能为空', trigger:'blur'},
          { type: 'number', message: '数量必选大于0'}
        ],
        // activity:[
        //   { type: 'number', min:0, max:100, message: '数量必选大于0小于100', trigger:'blur'}
        // ],
        shopNum:[{ required: true, message: '请选着分店', trigger: 'blur' }],
        subtitle:[{ required:true,message:'请输入票说明',trigger:'blur' }],
        bigintime:[
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endtime:[
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
        validityTime:[
          { required: true, message: '有效期不能为空'},
          { type: 'number',min:0, message: '有效期必须是大于等于0的数字'}
        ]
      },
      weekS:[
        {label:'星期一',value:'1'},
        {label:'星期二',value:'2'},
        {label:'星期三',value:'3'},
        {label:'星期四',value:'4'},
        {label:'星期五',value:'5'},
        {label:'星期六',value:'6'},
        {label:'星期日',value:'7'},
      ],
      favorabletypeS:[
        {label:'折扣',value:1},
        {label:'赠品',value:2},
      ],
      timeList:[],
      addType:1,
      buyNum:'',//买多少
      giveNum:'',//赠送多少
      formparams:{
          typeId:'',//票类型
          ticketName:'',//票名称
          price:'',//票价
          number:'',//数量
          saleNum: '', //购买数量
          subtitle:'',//说明,
          shopNum:'',
          bigintime:'',//开始时间
          endtime:'',//结束时间
          useTime:'',//使用时间
          validityTime:'',//有效期，
          favorabletype:'',//活动方式
          activity:'',//折扣优惠
          activeStartTime:'',//活动开始时间
          activeEndTime:'',//活动结束时间
          isreduce: '0', //是否限量
          isRestrictionSaleNum: '0', //是否限制购买数量
      },
      newData:{},
      formData:{},
      fileList:[],
      //票列表
      tableData:[],
      //票类型
      options:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        shopNum:null,
        name:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  components: {
    EditorBar
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  beforeCreate(){
    that = this
  },
  created(){
    this.getShopsList()
    if(this.$route.query.queryParams){
      this.params = JSON.parse(this.$route.query.queryParams)
      this.currentPage = 2
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    queryList(){
      this.params.pageNo=1
      this.currentPage = 1
      this.getTableList()
    },
    showDialog(){
        this.addType = 1
        this.dialogVisible =true
        // this.getShopsList()
        this.newData = ''
        this.formparams.ticketName= ''
        this.formparams.typeId = ''
        this.formparams.bigintime = ''
        this.formparams.endtime = ''
        this.formparams.shopNum = ''
        this.formparams.validityTime = ''
        this.formparams.isreduce = '0'
        this.formparams.isRestrictionSaleNum = '0'
        this.formparams.number = ''
        this.formparams.saleNum = ''
        this.formparams.price = ''
        this.formparams.subtitle = ''
        this.hideUpload = false
        this.timeList = []
        this.fileList=[]
        this.date=[]
        this.formparams.activity = ''
        this.formparams.favorabletype=''//活动方式
        this.formparams.activeStartTime=''//活动开始时间
        this.formparams.activeEndTime=''//活动结束时间
        this.getTicketType()
        this.clearForm('formparams')
    },
    getTableList(){
      this.loading = true
      getOnlineTicketInfo(this.params).then((res)=>{
        if(res.msg=='success'){
          this.tableData = res.data.info
          this.total = res.data.total
        }else{
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    gobackTicket(row){
      this.$router.push({path:'/buyTicket/backticket',query:{shortName:row.shortName,type:4,shopNum:row.shopnum,name:row.name,queryParams:JSON.stringify(this.params)}})
    },
    goCardTicket(row){
      this.$router.push({path:'/buyTicket/cardticket',query:{shopNum:row.shopnum,name:row.name,id:row.id}})
    },
    //查询票类型
    getTicketType(){
      getTicketTypes().then((res)=>{
        this.titleList = []
        for (let i = 0; i < res.data.length; i++) {
          this.titleList.push({value:res.data[i].ticketType,text:res.data[i].ticketType})
        }
        this.options = res.data
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.params.shopNum = this.shopList[0].shopNum
          this.showShop = false
        } else {
          this.showShop = true
        }
      })
    },
    filterHandler(value, row, column) {
      // const property = column.property;
      // console.log(row)
      return row.tbTicketType.ticketType === value;
    },
    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    uploadFile(file){
      this.formData = new FormData()
      this.formData.append('uploadFile', file.file);
    },
    // getValue(){
    //   console.log( this.timeList.join('/'))
    // },
    //编辑
    edit(row){
      this.addType = 2
      this.dialogVisible = true
      this.newData = row
      this.formparams.ticketName= row.name
      this.formparams.typeId = row.tbTicketType.tid
      this.formparams.ticketId = row.id
      this.formparams. ticketConfigId = row.ticketConfig.id
      this.formparams.bigintime = row.ticketConfig.bigintime
      this.formparams.endtime = row.ticketConfig.endtime
      this.formparams.shopNum = row.shopnum
      this.formparams.validityTime = row.ticketConfig.validitytime
      if(row.isreduce) {
        this.formparams.isreduce = row.isreduce
      }
      if(row.ticketConfig.isRestrictionSaleNum) {
        this.formparams.isRestrictionSaleNum = row.ticketConfig.isRestrictionSaleNum
      }
      this.formparams.number = row.number
      this.formparams.saleNum = row.ticketConfig.saleNum
      this.formparams.price = parseFloat(row.price)
      this.formparams.subtitle = row.subtitle
      if(row.ticketConfig.favorabletype){
        this.formparams.favorabletype= parseInt(row.ticketConfig.favorabletype)
        if(row.ticketConfig.favorabletype == 1){
          this.formparams.activity = row.ticketConfig.activity
        } else {
          this.buyNum = row.ticketConfig.activity.split('/')[0]
          this.giveNum = row.ticketConfig.activity.split('/')[1]
        }
      } else {
        this.formparams.favorabletype= ''
        this.formparams.activity= ''
        this.buyNum=''
        this.giveNum =''
      }
      if(row.ticketConfig.activeendtime||row.ticketConfig.activestarttime){
        this.date=[row.ticketConfig.activestarttime,row.ticketConfig.activeendtime]
      } else{
        this.date =[]
      }

      if(this.fileList){
        this.hideUpload = true
      } else {
        this.hideUpload = false
      }
      this.timeList = []
      this.timeList=row.ticketConfig.usetime.split('/')
      // for (let i = 0; i < row.ticketConfig.usetime.length; i++) {
      //   row.ticketConfig.usetime.split('/')

      //   // this.timeList.push(parseInt(row.ticketConfig.usetime[i]))
      // }
      this.fileList=[]
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.picture})
      this.clearForm('formparams')
    },
    //下架票
    removeList(id){
      // ticketId
      this.$confirm('此操作将下架当前票, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateTicketInfo({ticketId:id, type: '0'}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'下架成功'
              })
              this.getTableList()
            }else{
              this.$message.error(res.data);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下架'
          });          
        });
    },
    //上架票
    addList(id){
      // ticketId
      this.$confirm('此操作将上架当前票, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateTicketInfo({ticketId:id, type: '1'}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'上架成功'
              })
              this.getTableList()
            }else{
              this.$message.error(res.data);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消上架'
          });          
        });
    },
    //添加票
    // insertOnlineTicketInfo
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if(this.$refs.upload.uploadFiles.length==0){
          this.$message.error('上传票的不能为空');
          return
        } else {
          if(this.$refs.upload.uploadFiles[0].size/1024>500){
              this.$message.error('上传图片大小不能超过500kb');
              this.fileList= []
              this.hideUpload= false
              return
          }
          if(this.$refs.upload.uploadFiles[0].name){
            let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
            var re;
            re =  /^[A-Za-z0-9]+$/g;
            if (!re.test(nameARR[0])) {
              this.$message.error('上传图片名称只能是数字字母组合');
              this.fileList= []
              this.hideUpload= false
              return
            }
          }
        }
        if (valid) {
          let config = {
              headers: {
                'Content-Type':'multipart/form-data',
                'token':sessionStorage.getItem('token')
              }
          }
          if(this.date.length!=''){
            this.formparams.activeStartTime = this.date[0].trim();
            this.formparams.activeEndTime = this.date[1].trim();
          }
          if(this.formparams.favorabletype==2){
            this.formparams.activity = this.buyNum+'/'+this.giveNum
          }
          if(this.addType ==1){
            this.formData = new FormData()
            this.$refs.upload.submit();
            this.formData.append('typeId', this.formparams.typeId);
            this.formData.append('shopNum', this.formparams.shopNum);
            this.formData.append('ticketName', this.formparams.ticketName);
            this.formData.append('price', this.formparams.price);
            this.formData.append('isreduce', this.formparams.isreduce);
            this.formData.append('isRestrictionSaleNum', this.formparams.isRestrictionSaleNum);
            if(this.formparams.number>=0){
              this.formData.append('number', this.formparams.number);
            }
            if(this.formparams.saleNum>=0){
              this.formData.append('saleNum', this.formparams.saleNum);
            }
            this.formData.append('subtitle', this.formparams.subtitle);
            this.formData.append('bigintime', this.formparams.bigintime);
            this.formData.append('endtime', this.formparams.endtime);
            this.formparams.useTime = this.timeList.join('/')
            this.formData.append('useTime', this.formparams.useTime);
            this.formData.append('validityTime', this.formparams.validityTime);
            this.formData.append('favorabletype', this.formparams.favorabletype);
            if(this.formparams.activity!=''){
              if(this.formparams.activity>100){
                this.$message.error('折扣不能大于100')
                return
              }
            }
            this.formData.append('activity', this.formparams.activity);
            this.formData.append('activeStartTime', this.formparams.activeStartTime);
            this.formData.append('activeEndTime', this.formparams.activeEndTime);
            this.$http.post('ticket/insertOnlineTicketInfo', this.formData, config).then((res)=>{
              // console.log(res)
              if(res.data.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'添加成功'
                })
              }else{
                this.dialogVisible = true
                this.$message.error(res.data.data);
              }
              this.getTableList()
            })
          } else {
            this.formData = new FormData()
            this.$refs.upload.submit();
            if(this.newData.name!=this.formparams.ticketName){
              this.formData.append('ticketName', this.formparams.ticketName); 
            }
            if(this.newData.price!=this.formparams.price){
                this.formData.append('price', this.formparams.price);
            }
            if(this.newData.isreduce!=this.formparams.isreduce){
              this.formData.append('isreduce', this.formparams.isreduce); 
            }
            if(this.newData.isRestrictionSaleNum!=this.formparams.isRestrictionSaleNum){
              this.formData.append('isRestrictionSaleNum', this.formparams.isRestrictionSaleNum); 
            }
            if(this.newData.number!=this.formparams.number){
              this.formData.append('number', this.formparams.number); 
            }
            if(this.newData.saleNum!=this.formparams.saleNum){
              this.formData.append('saleNum', this.formparams.saleNum); 
            }
            if(this.newData.subtitle!=this.formparams.subtitle){
              this.formData.append('subtitle', this.formparams.subtitle); 
            }
            if(this.newData.shopnum!=this.formparams.shopNum){
              this.formData.append('shopNum', this.formparams.shopNum); 
            }
            if(this.newData.ticketConfig.bigintime!=this.formparams.bigintime){
              this.formData.delete('ticketConfigId')
              this.formData.append('ticketConfigId', this.formparams.ticketConfigId);
              this.formData.append('bigintime', this.formparams.bigintime); 
            }
            if(this.newData.ticketConfig.endtime!=this.formparams.endtime){
              this.formData.delete('ticketConfigId')
              this.formData.append('ticketConfigId', this.formparams.ticketConfigId);
              this.formData.append('endtime', this.formparams.endtime); 
            }
            this.formData.append('ticketId', this.formparams.ticketId);
            this.formparams.useTime = this.timeList.join('/')
            this.formData.append('useTime', this.formparams.useTime); 
            if(this.newData.ticketConfig.validitytime!=this.formparams.validityTime){
              this.formData.delete('ticketConfigId')
              this.formData.append('ticketConfigId', this.formparams.ticketConfigId);
              this.formData.append('validityTime', this.formparams.validityTime); 
            }
            if(this.newData.ticketConfig.favorabletype!=this.formparams.favorabletype){
              this.formData.delete('ticketConfigId')
              this.formData.append('ticketConfigId', this.formparams.ticketConfigId);
              this.formData.append('favorabletype', this.formparams.favorabletype); 
            }
            if(this.formparams.activity!=''){
              if(this.formparams.activity>100){
                this.$message.error('折扣不能大于100')
                return
              }
            }
            if(this.newData.ticketConfig.activity!=this.formparams.activity){
              this.formData.delete('ticketConfigId')
              this.formData.append('ticketConfigId', this.formparams.ticketConfigId);
              this.formData.append('activity', this.formparams.activity); 
            }
            if(this.newData.ticketConfig.activeStartTime!=this.formparams.activeStartTime){
              this.formData.delete('ticketConfigId')
              this.formData.append('ticketConfigId', this.formparams.ticketConfigId);
              this.formData.append('activeStartTime', this.formparams.activeStartTime); 
            }
            if(this.newData.ticketConfig.activeEndTime!=this.formparams.activeEndTime){
              this.formData.delete('ticketConfigId')
              this.formData.append('ticketConfigId', this.formparams.ticketConfigId);
              this.formData.append('activeEndTime', this.formparams.activeEndTime); 
            }
            this.$http.post('ticket/updateOnlineTicketInfo', this.formData, config).then((res)=>{
              // console.log(res)
              if(res.data.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              }else{
                this.dialogVisible = true
                this.$message.error(res.data.data);
              }
              this.getTableList()
            })
          } 
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    clearForm(formName) {
      if(this.$refs[formName]!=undefined){
        this.$refs[formName].clearValidate();
      }
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
.menuTree{
  width: 400px;
  height:auto;
  max-height: 300px;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// buyTicket.vue?6b27d22c